import React from 'react';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import './Mobility.css';
import MobilityDetails from './MobilityDetails';
import RentalContractConfiguration from './RentalContractConfiguration';
import {SpinnerModal} from '../../public/components/SpinnerModal';
import {withAuthorization} from '../../services/Authorization';
import Storage from '../../services/Storage';

class Mobility extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      mobility: {
        categoryMobility: [],
        otherMobility: [],
        serviceMobility: [],
        extraMobility: [],
        rentalContractConfiguration: {}
      },
    }
  }

  componentDidMount() {
    this.props.dispatchFetchMobility();
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.fetchMobility && nextProps.fetchMobility.mobility) {
      this.setState({mobility: nextProps.fetchMobility.mobility})
    }
  };

  save = () => {
    this.props.dispatchSaveMobility(this.state.mobility);
  };

  onConfigurationUpdate = configuration => {
    const {mobility} = this.state;
    mobility.rentalContractConfiguration = configuration;
    this.setState({mobility});
  };

  render() {
    const {intl: {formatMessage}, loading, saveMobility} = this.props;
    const {mobility, mobility: {rentalContractConfiguration}} = this.state;
    const user = Storage.getItem('user');
    const canWrite = user.role === 'DUI_ADMIN';
    const {error: {content: errors = {}} = {}} = saveMobility;

    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id: 'section.mobility.title'})}
          </h2>
          <div className="box-heading__right">
            <SpinnerModal visible={loading}/>
          </div>
          {canWrite &&
            <div className="box-heading__button">
              <button onClick={this.save} disabled={loading} type="primary" className="btn btn-sm btn-primary">
                {formatMessage({id: 'action.save'})}
              </button>
            </div>
          }
        </header>
        {
          <div className={"mobility"}>
            <RentalContractConfiguration configuration={rentalContractConfiguration} onUpdate={this.onConfigurationUpdate} errors={errors}/>
            <MobilityDetails mobility={mobility} errors={errors}/>
          </div>
        }
      </section>
    )
  }
}

const mapStateToProps = state => ({
  fetchMobility: state.fetchMobility,
  saveMobility: state.saveMobility,
  loading: state.fetchMobility.loading || state.saveMobility.loading,
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchMobility: () => dispatch({type: 'FETCH_MOBILITY.REQUEST'}),
  dispatchSaveMobility: (body) => dispatch({type: 'SAVE_MOBILITY.REQUEST', body})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(Mobility), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));
